<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>
        <slot></slot>
      </div>
      <div class="panel-content">
        <div class="panel-article">
          <p v-for="(item, index) in computedText" :key="index">
            {{ item.content }}
          </p>
        </div>
        <div class="answer_result">
          <div class="answer_result-title">{{ $t('mark_answer') }}:</div>
          <div v-if="inputTitle || inputTextResult.length">
            <p class="title">{{ inputTitle }}</p>
            <p class="text" v-for="(item, index) in inputTextResult" :key="index">
              {{ item.trim() }}
            </p>
          </div>
          <strong v-else>{{ $t('hsk_homework_no_answer') }}</strong>
          <div class="limit">{{ wordLength || 0 + '/400' }}</div>
        </div>
        <div class="reference_answer">
          <div>{{ $t('hsk_reference_answer') }}</div>
          <p v-for="(item, index) in analysisText" :key="index">
            {{ item.trim() }}
          </p>
        </div>
        <AiSuggestScore :score="currItem.aiScores" />
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
export default {
  name: 'CommonWriteSxResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      inputTitle: '',
      inputText: '', // 统计所有文本字数
      inputTextResult: [],
    }
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.index) {
          if (val.useAnswer) {
            this.inputTitle = val.useAnswer.split('&&')[0]
            this.inputText = val.useAnswer.split('&&')[1]
            console.log(val.useAnswer)
            this.inputTextResult = val.useAnswer.split('&&')[1].split('\n') || []
            console.log(this.inputTextResult)
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    wordLength() {
      return getAllWordsLength(this.inputTitle) + getAllWordsLength(this.inputText)
    },
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },
    computedText() {
      return this.currItem?.screen_text.slice(1, this.currItem?.screen_text.length)
    },
    analysisText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  .answer_result {
    &-title {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      text-indent: 2em;
      line-height: 25px;
    }
    strong {
      font-weight: 600;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
  }
}
</style>
